import { createElement } from 'react'
import QuestionKey from './question-key'
import QuestionList from './question-list'

const getQuestion = (
  key: QuestionKey,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  existingAnswers: any,
  questionIndex: number,
  returningViaPrevious: boolean,
  errors?: { [key: string]: boolean },
  bouncerError?: string
): JSX.Element => createElement(
  QuestionList[key],
  {
    existingAnswers,
    disablePrevious: questionIndex === 0,
    questionKey: key,
    returningViaPrevious,
    errors,
    bouncerError
  }
)

export default {
  getQuestion
}
